import { render } from "./ShoprenterInstallView.vue?vue&type=template&id=2fc05d41"
import script from "./ShoprenterInstallView.vue?vue&type=script&lang=js"
export * from "./ShoprenterInstallView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/ShoprenterInstallView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fc05d41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fc05d41', __exports__)) {
    api.reload('2fc05d41', __exports__)
  }
  
  module.hot.accept("./ShoprenterInstallView.vue?vue&type=template&id=2fc05d41", () => {
    api.rerender('2fc05d41', render)
  })

}


export default __exports__